module.exports = __webpack_public_path__ + "img/headphones.708d980b.png";